@if (config) {
  <div class="highlight">
    <giq-area-chart class="chart" [info]="info" [hideIndicators]="true"></giq-area-chart>
  </div>
}